// Helpers for the duty-payment transactions list.

// Payment statuses (match payments.constants.STATUS_LIST on the backend).
export const STATUS_OPTIONS = [
  { value: 'INITIALIZED', label: 'Initialized' },
  { value: 'PROCESSING', label: 'Processing' },
  { value: 'SUCCESSFUL', label: 'Successful' }
]

// How the customer paid (spec: duty-merchant-payment-tracking). MERCHANT means they sent it to
// our merchant MoMo number, so a human confirms it — that is the row someone has to act on.
export const PAYMENT_MODE_OPTIONS = [
  { value: 'merchant', label: 'Merchant MoMo' },
  { value: 'automatic', label: 'Automatic (Paystack)' }
]

export const PAYMENT_MODE_COLORS = {
  merchant: 'gold',
  automatic: 'blue'
}

export const PAYMENT_MODE_LABELS = {
  merchant: 'Merchant',
  automatic: 'Automatic'
}

// The claimed MoMo name out of a merchant transaction's note ("Merchant MoMo claimed by X / Y"),
// which is what gets matched against the merchant statement. Falls back to the whole note.
export const claimedName = note => {
  if (!note) return ''
  const match = /claimed by (.+)$/im.exec(note)
  return (match ? match[1] : note).trim()
}

// Which company moves the money (spec: payment-gateway-routing). A RAIL is how the customer pays;
// a GATEWAY is the company that moves it on that rail, and `manual` is not a company at all — it
// is a person confirming that money arrived, which is the honest name for merchant and bank.
export const GATEWAY_LABELS = {
  paystack: 'Paystack',
  mtn_momo: 'MTN MoMo',
  manual: 'Our team'
}

export const GATEWAY_COLORS = {
  paystack: 'blue',
  mtn_momo: 'gold',
  manual: 'default'
}

// Filter options. Written out rather than read from `/gateways/`, because this list is a FILTER
// over rows that already exist: a gateway nothing has ever been paid through is not worth a row
// in a dropdown, and one we have retired still has payments to look up.
export const GATEWAY_OPTIONS = [
  { value: 'paystack', label: 'Paystack' },
  { value: 'mtn_momo', label: 'MTN MoMo' },
  { value: 'manual', label: 'Our team' }
]

export const RAIL_OPTIONS = [
  { value: 'momo', label: 'Mobile money' },
  { value: 'card', label: 'Card' },
  { value: 'merchant', label: 'Merchant MoMo' },
  { value: 'bank', label: 'Bank transfer' }
]

export const STATUS_COLORS = {
  INITIALIZED: 'gold',
  PROCESSING: 'orange',
  SUCCESSFUL: 'green'
}

export const formatMoney = (amount, currency = 'GHS') => {
  const n = Number(amount || 0)
  return `${currency} ${n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

// Build a querystring from the active filters, omitting blanks. `range` is a [moment, moment]
// pair from antd RangePicker (or null). Dates are sent as ISO so the backend DateTimeFilter
// matches created_after / created_before.
export const buildQuery = ({ status, search, range, paymentMode, gateway, rail }) => {
  const params = new URLSearchParams()
  if (status) params.append('status', status)
  if (paymentMode) params.append('payment_mode', paymentMode)
  // Snake_case on the way out: the admin API's query params are snake throughout, and only JSON
  // BODIES are camelized.
  if (gateway) params.append('gateway', gateway)
  if (rail) params.append('rail', rail)
  if (search) params.append('search', search)
  if (range && range[0]) params.append('created_after', range[0].toISOString())
  if (range && range[1]) params.append('created_before', range[1].toISOString())
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}
